var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { WebPlugin } from '@capacitor/core';
export class CapacitorTcpWeb extends WebPlugin {
    constructor() {
        super({
            name: 'CapacitorTcp',
            platforms: ['web'],
        });
    }
    echo(options) {
        return __awaiter(this, void 0, void 0, function* () {
            console.log('ECHO', options);
            return options;
        });
    }
    create(options) {
        return __awaiter(this, void 0, void 0, function* () {
            console.log('CREATE', options);
            return { socketId: 0, ipv4: "", ipv6: "" };
        });
    }
    update(options) {
        return __awaiter(this, void 0, void 0, function* () {
            console.log('UPDATE', options);
            return {};
        });
    }
    setPaused(options) {
        return __awaiter(this, void 0, void 0, function* () {
            console.log('PAUSED', options);
            return {};
        });
    }
    setKeepAlive(options) {
        return __awaiter(this, void 0, void 0, function* () {
            console.log('KEEP ALIVE', options);
            return {};
        });
    }
    setNoDelay(options) {
        return __awaiter(this, void 0, void 0, function* () {
            console.log('NO DELAY', options);
            return {};
        });
    }
    connect(options) {
        return __awaiter(this, void 0, void 0, function* () {
            console.log('CONNECT', options);
            return {};
        });
    }
    disconnect(options) {
        return __awaiter(this, void 0, void 0, function* () {
            console.log('DISCONNECT', options);
            return {};
        });
    }
    secure(options) {
        return __awaiter(this, void 0, void 0, function* () {
            console.log('SECURE', options);
            return {};
        });
    }
    send(options) {
        return __awaiter(this, void 0, void 0, function* () {
            console.log('SEND', options);
            return {};
        });
    }
    close(options) {
        return __awaiter(this, void 0, void 0, function* () {
            console.log('CLOSE', options);
            return {};
        });
    }
    getInfo(options) {
        return __awaiter(this, void 0, void 0, function* () {
            console.log('GET INFO', options);
            return { socketId: 0, bufferSize: 0, name: null, paused: false, connected: false };
        });
    }
    getSockets() {
        return __awaiter(this, void 0, void 0, function* () {
            return { sockets: [{ socketId: 0, bufferSize: 0, name: null, paused: false, connected: false }] };
        });
    }
}
const CapacitorTcp = new CapacitorTcpWeb();
export { CapacitorTcp };
import { registerWebPlugin } from '@capacitor/core';
registerWebPlugin(CapacitorTcp);
//# sourceMappingURL=web.js.map